import { Link } from 'react-router-dom';
import Reveal from '@/components/base/Reveal';

export default function CtaSection() {
  return (
    <section className="w-full bg-primary-500 py-14 md:py-16">
      <div className="mx-auto flex w-full flex-col items-center gap-6 px-4 text-center md:px-6">
        <Reveal>
          <span className="flex items-center justify-center gap-2 font-label text-xs tracking-[0.2em] text-primary-100">
            <i className="ri-fire-line"></i>
            第三季作品持续更新中
          </span>
          <h2 className="mt-4 max-w-2xl font-heading text-2xl font-black text-background-50 md:text-3xl">
            两百多篇作品已经排好队，挑一篇开始看
          </h2>
          <p className="mt-4 max-w-xl font-body text-sm leading-relaxed text-primary-50 md:text-base">
            想按热度看就进作品合集，想认识写这些内容的人也欢迎先逛一圈选手盘点。
          </p>
          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Link
              to="/works"
              className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-6 py-3 font-label text-sm text-primary-700 transition-colors hover:bg-background-100 sm:w-auto"
            >
              <i className="ri-stack-line"></i>
              进入作品合集
            </Link>
            <Link
              to="/contestants"
              className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-primary-200 px-6 py-3 font-label text-sm text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
            >
              <i className="ri-user-star-line"></i>
              看选手盘点
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}